<div [hidden]="showRequest">
  <h2 *ngIf="!IsAdminMode" class="sectionTitle">{{'FRONT_USER.CREW_CHANGE_FORM.FORM' | translate }}
  </h2>
   <!--request Details summary-->
   <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>

   <!-- Show Rejection Reason From Reviewer -->
    <div *ngIf="showRejectionReasonByReviewer">
      <div class="form-container">
          <h4 class="section-title">{{'FRONT_USER.CREW_CHANGE_FORM.REJECTION_REASON'| translate}}</h4>
          <div class="form-group">
              <textarea [(ngModel)]="rejectionReasonByReviewer" id="rejectionReasonByReviewer" name="rejectionReasonByReviewer"
                  disabled class="form-control"></textarea>
          </div>
      </div>
    </div>

    <!-- Show Rejection Reason From Approval -->
    <div *ngIf="showRejectionReasonByApproval">
      <div class="form-container">
          <h4 class="section-title">{{'FRONT_USER.CREW_CHANGE_FORM.REJECTION_REASON'| translate}}</h4>
          <div class="form-group">
              <textarea [(ngModel)]="rejectionReasonByApproval" id="rejectionReasonByApproval" name="rejectionReasonByApproval"
                  disabled class="form-control"></textarea>
          </div>
      </div>
    </div>

    <!-- Show More Information Requested from Agent -->
    <div *ngIf="showMoreInfoFromAgent">
        <div class="form-container">
            <h4 class="section-title">{{'FRONT_USER.CREW_CHANGE_FORM.MORE_INFORMATION_FROM_AGENT'| translate}}</h4>
            <div class="form-group">
                <label for="moreInfomationFromAgent">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
                    translate}}</label>
                <textarea [(ngModel)]="moreInfomationFromAgent" id="moreInfomationFromAgent" name="moreInfomationFromAgent"
                    disabled class="form-control"></textarea>
            </div>
        </div>
    </div>

    <!-- Show More Information Requested from Reviewer -->
    <div *ngIf="showMoreInfoFromReviewer">
      <div class="form-container">
          <h4 class="section-title">{{'FRONT_USER.CREW_CHANGE_FORM.MORE_INFORMATION_FROM_REVIEWER'| translate}}</h4>
          <div class="form-group">
              <label for="moreInfomationFromReviewer">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
                  translate}}</label>
              <textarea [(ngModel)]="moreInfomationFromReviewer" id="moreInfomationFromReviewer" name="moreInfomationFromReviewer"
                  disabled class="form-control"></textarea>
          </div>
      </div>
    </div>

   <form [formGroup] = "crewChangeForm" #crewChange>
    <div class="form-container">
      <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>
    </div>
    <tabset #CrewChangeTabs>
      <tab #tabOneControls heading="{{ 'FRONT_USER.FEES_ESTIMATION_TABS.VESSEL_PARTICULARS' | translate}}">
          <div class="form-container">

            <!-- VesselName -->
            <div class="form-group">
              <label for="VesselName">{{ 'FRONT_USER.CREW_CHANGE_FORM.VESSEL_NAME' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="VesselName" id="VesselName" class="form-control" formControlName="VesselName" />
              <div *ngIf="isTabOneSubmitted || (f.VesselName?.dirty && f.VesselName?.errors)" class="red ">
                <div *ngIf="f.VesselName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>

            <!-- IMONO -->
             <div class="form-group">
              <label for="IMONO">{{ 'FRONT_USER.CREW_CHANGE_FORM.IMONO' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="IMONO" id="IMONO" class="form-control" formControlName="IMONO" />
              <div *ngIf="isTabOneSubmitted || (f.IMONO?.dirty && f.IMONO?.errors)" class="red ">
                <div *ngIf="f.IMONO?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.IMONO?.errors?.pattern">{{'FRONT_USER.IMO_ERROR' | translate}}</div>
                <div *ngIf="f.IMONO?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <!-- Vessel Type -->
            <div class="form-group">
              <label for="VesselTypeId">{{'FRONT_USER.CREW_CHANGE_FORM.VESSEL_TYPE'| translate}}</label>
              <span class="red">*</span>
              <select (change)="vesselTypeChanged($event)" formControlName="VesselTypeId" class="form-control">
                <option [value]='null' selected>
                  {{'FRONT_USER.CREW_CHANGE_FORM.VESSEL_TYPE_CHOOSE' | translate}}
                </option>
                <ng-container *ngFor="let vessel of vesselTypes">
                  <option *ngIf="displayedLang==Languages.English" [value]="vessel.Id">
                    {{vessel.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="vessel.Id">
                    {{vessel.NameAR}}
                  </option>
                </ng-container>
              </select>
              <div
                *ngIf="isTabOneSubmitted ||(f.VesselTypeId?.dirty && (f.VesselTypeId?.errors || f.VesselTypeId?.value=='null'))"
                class="red ">
                <div *ngIf="f.VesselTypeId?.errors?.required || f.VesselTypeId?.value=='null'">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- show Vessel Other -->
            <div *ngIf="showVesselOther" class="form-group">
              <label for="VesselTypeOther">{{'FRONT_USER.CREW_CHANGE_FORM.VESSEL_OTHER'| translate}}</label>
              <span class="red">*</span>
              <input type="text" name="VesselTypeOther" id="VesselTypeOther" class="form-control"
                formControlName="VesselTypeOther" />
              <div *ngIf="isTabOneSubmitted ||(f.VesselTypeOther?.dirty && f.VesselTypeOther?.errors )" class="red ">
                <div *ngIf="f.VesselTypeOther?.errors?.required ">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- Vessel Nationality -->
            <div class="form-group">
              <label for="NationalityId">{{ 'FRONT_USER.CREW_CHANGE_FORM.VESSEL_FLAG' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="NationalityId" class="form-control">
                <option [value]="''" selected>
                  {{'FRONT_USER.CREW_CHANGE_FORM.CHOOSE_FLAG' | translate}}
                </option>
                <ng-container *ngFor="let nationality of nationalities">
                  <option *ngIf="displayedLang==Languages.English" [value]="nationality.Id">
                    {{nationality.NameEN}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="nationality.Id">
                    {{nationality.NameAR}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="isTabOneSubmitted ||(f.NationalityId?.dirty &&f.NationalityId?.errors)" class="red ">
                <div *ngIf="f.NationalityId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <!-- Direction -->
            <div class="form-group">
              <label for="SailDirectionId">{{ 'FRONT_USER.CREW_CHANGE_FORM.DIRECTION' | translate}}</label>
              <span class="red">*</span>
              <select formControlName="SailDirectionId" class="form-control" id="SailDirectionId" name="Direction">
                <option [value]="''" selected>
                  {{'FRONT_USER.CREW_CHANGE_FORM.CHOOSE_DIRECTION' | translate}}</option>
                <ng-container *ngFor="let direction of directions">
                  <option *ngIf="displayedLang==Languages.English" [value]="direction?.Id">
                    {{direction?.Direction}}
                  </option>
                  <option *ngIf="displayedLang==Languages.Arabic" [value]="direction?.Id">
                    {{direction?.DirectionAR}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="isTabOneSubmitted ||(f.SailDirectionId?.dirty && f.SailDirectionId?.errors)" class="red ">
                <div *ngIf="f.SailDirectionId?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- From Port -->
            <div class="form-group">
              <label for="FromPort">{{ 'FRONT_USER.CREW_CHANGE_FORM.LAST_PORT' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="FromPort" id="FromPort" class="form-control" formControlName="FromPort" />
              <div *ngIf="isTabOneSubmitted ||(f.FromPort?.dirty &&f.FromPort?.errors)" class="red ">
                <div *ngIf="f.FromPort?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.FromPort?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <!-- To Port -->
            <div class="form-group">
              <label for="ToPort">{{ 'FRONT_USER.CREW_CHANGE_FORM.NEXT_PORT' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" name="ToPort" id="ToPort" class="form-control" formControlName="ToPort" />
              <div *ngIf="isTabOneSubmitted ||(f.ToPort?.dirty &&f.ToPort?.errors)" class="red ">
                <div *ngIf="f.ToPort?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.ToPort?.errors?.startsWithSpaceError">
                  {{'FRONT_USER.START_WITH_SPACE' | translate}}
                </div>
              </div>
            </div>

            <!-- Transit Date -->
            <div class="form-group">
              <label for="TransitDate">{{ 'FRONT_USER.CREW_CHANGE_FORM.TRANSIT_DATE' | translate}}</label>
              <span class="red"> *</span>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="TransitDate">
              <div *ngIf="isTabOneSubmitted ||(f.TransitDate?.dirty && f.TransitDate?.errors)" class="red ">
                <div *ngIf="f.TransitDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                <div *ngIf="f.TransitDate?.errors?.inValidDateError">
                  {{'FRONT_USER.DATE_ERROR' | translate}}
                </div>
              </div>
            </div>

            <!-- Service Type -->
            <div class="form-group">
              <label for="ServiceTypeId">{{'FRONT_USER.CREW_CHANGE_FORM.SERVICE_TYPE'| translate}}</label>
              <span class="red">*</span>
              <select formControlName="ServiceTypeId" class="form-control" (change)="OnServiceTypeChange($event)">
                <option [value]='null' selected>
                  {{'FRONT_USER.CREW_CHANGE_FORM.CHOOSE_SERVICE_TYPE' | translate}}
                </option>
                <ng-container *ngFor="let serviceTypeKey of serviceTypeKeys">
                  <option [value]="serviceType[serviceTypeKey]">
                    {{serviceTypeKey}}
                  </option>
                </ng-container>
              </select>
              <div
                *ngIf="isTabOneSubmitted ||(f.ServiceTypeId?.dirty && (f.ServiceTypeId?.errors || f.ServiceTypeId?.value=='null'))"
                class="red ">
                <div *ngIf="f.ServiceTypeId?.errors?.required || f.ServiceTypeId?.value=='null'">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

            <!-- Service Location -->
            <div class="form-group">
              <label for="ServiceLocationId">{{'FRONT_USER.CREW_CHANGE_FORM.SERVICE_LOCATION'| translate}}</label>
              <span class="red">*</span>
              <select formControlName="ServiceLocationId" class="form-control">
                <option [value]='null' selected>
                  {{'FRONT_USER.CREW_CHANGE_FORM.CHOOSE_SERVICE_LOCATION' | translate}}
                </option>
                <ng-container *ngFor="let serviceLocationKey of serviceLocationKeys">
                  <option [value]="serviceLocation[serviceLocationKey]">
                    {{serviceLocationKey}}
                  </option>
                </ng-container>
              </select>
              <div
                *ngIf="isTabOneSubmitted ||(f.ServiceLocationId?.dirty && (f.ServiceLocationId?.errors || f.ServiceLocationId?.value=='null'))"
                class="red ">
                <div *ngIf="f.ServiceLocationId?.errors?.required || f.ServiceLocationId?.value=='null'">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div>
            </div>

          </div>

          <p class="btns-holder text-right">
            <button type="button" class="btn  SCAcustomBtn"
              (click)="selectTab(1)">{{ 'FRONT_USER.NEXT' | translate}}</button>
          </p>

      </tab>


        <tab #tabTwoControls heading="{{ 'FRONT_USER.CREW_CHANGE_FORM.CREW_DETAILS' | translate}}"
      [disabled]="!isTabOneValid">

      <div formArrayName="EmbarkingCrewDetails" *ngIf="embarkingDetails">
        <div class="form-container">
          <h4 class="section-title">{{ 'FRONT_USER.CREW_CHANGE_FORM.EMBARKING_CREW_DETAILS' | translate}}</h4>
        </div>

        <div *ngFor="let crewMember of crewChangeForm.get('EmbarkingCrewDetails').controls; let i=index; let last = last"
          [formGroupName]="i">
          <div class="form-container">
            <!-- Member Name -->
            <div class="form-group">
              <label for="Name">{{ 'FRONT_USER.CREW_CHANGE_FORM.MEMBER_NAME' | translate}}</label>
              <span class="red">*</span>
              <input type="text" formControlName="Name" class="form-control"
                [ngClass]="{ 'is-invalid':formSubmitted ||( crewMember.get('Name')?.dirty && crewMember.get('Name')?.errors) }" />
              <div
                *ngIf=" formSubmitted ||(crewMember.get('Name')?.dirty && crewMember.get('Name')?.errors)"
                class="red ">
                <div *ngIf="crewMember.get('Name')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <!-- PassportNumber -->
            <div class="form-group">
              <label for="PassportNumber">{{ 'FRONT_USER.CREW_CHANGE_FORM.PASSPORT_NUMBER' | translate}}</label>
              <span class="red">*</span>
              <input type="text" formControlName="PassportNumber" class="form-control"
                [ngClass]="{ 'is-invalid':formSubmitted ||( crewMember.get('PassportNumber')?.dirty && crewMember.get('PassportNumber')?.errors) }" />
              <div
                *ngIf=" formSubmitted ||(crewMember.get('PassportNumber')?.dirty && crewMember.get('PassportNumber')?.errors)"
                class="red ">
                <div *ngIf="crewMember.get('PassportNumber')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <!-- Attachment -->
            <div *ngIf="formMode != FormMode.Readonly" class="form-group">
              <label for="AttachmentURL">{{'FRONT_USER.CREW_CHANGE_FORM.DOCUMENT'| translate}}</label>
              <span *ngIf="formMode == FormMode.Add" class="red">*</span>
              <input type="file"
                accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                MaxSizeInMB="5" class="form-control" id="AttachmentURL" formControlName="AttachmentURL"
                (change)="onFileSelected($event,crewMember.get('AttachmentURL'),i,'E')" />
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>

              <!-- Progress Bar -->
              <div class="progress">
                <div  class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                  aria-valuemax="100" [style.width]="documentProgressE[i] + '%'">
                  <span class=""> {{ documentProgressE[i] }} % Complete</span>
                </div>
              </div>
              <div *ngIf=" formSubmitted ||(crewMember.get('AttachmentURL')?.dirty &&  crewMember.get('AttachmentURL')?.errors)"
                class="red">
                <div *ngIf="crewMember.get('AttachmentURL')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
                <div *ngIf="crewMember.get('AttachmentURL').errors?.notCompleted">
                    {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && requestCrewDetailsEmbarking[i] && showEmbarkingURL">
              <label>{{'FRONT_USER.CREW_CHANGE_FORM.DOCUMENT'|translate}}</label>
              <a [attr.href]="uploadUrl+uploadFolder+'/'+requestCrewDetailsEmbarking[i].AttachmentURL" target="_blank">
                <i class="icon-view-file"></i>
                {{requestCrewDetailsEmbarking[i].AttachmentURL?.split("_").slice(0, -1).join('_')}} <!-- Split the name of the file, take all the name except the last part after the last ('_') -->
              </a>
            </div>

            <input type="hidden" formControlName="ChangeDirection" [ngModel]="changeDirection.Embarking">
            <input type="hidden" formControlName="AddedBy" [ngModel]="currentUser.UserName">
            <input type="hidden" formControlName="Id">

            <p *ngIf="formMode != FormMode.Readonly">
              <button type="button" class="btn SCAcustomBtn" Confirmation
                (confirmationClick)="deleteCrewMember('E',i)"
                *ngIf="embarkingCrewDetailsLength > 1">
                {{'FRONT_USER.DELETE' | translate }}
              </button>
            </p>
          </div>
          <p *ngIf="last && formMode != FormMode.Readonly " class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="addCrewMember('E')">(+)
              {{'FRONT_USER.ADD' | translate }}</button>
          </p>
          <div class="form-group" *ngIf="getCrewMemberAddedBy(crewMember.get('Id').value) !== crewChangeDTO?.RequestorEmail">
            <label style="
              background-color: antiquewhite;
              padding: 5px 10px;
              margin: 5px;
              border-radius: 5px;">{{'FRONT_USER.CREW_CHANGE_FORM.ADDED_BY_ADMIN' | translate }}
            </label>
          </div>
          <!--Final Notes  -->
          <div class="form-group" *ngIf="getCrewMemberFinalNotes(crewMember.get('Id').value) !== ''">
            <label style="    
              background-color: antiquewhite;
              padding: 5px 10px;
              margin: 5px;
              border-radius: 5px;">{{'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.FINAL_NOTES' | translate }} : {{getCrewMemberFinalNotes(crewMember.get('Id').value)}}
            </label>
          </div>
        </div>
      </div>

      <hr *ngIf="showHR">

      <div formArrayName="DisembarkingCrewDetails" *ngIf="disEmbarkingDetails">
        <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.CREW_CHANGE_FORM.DISEMBARKING_CREW_DETAILS' | translate}}</h4>
        </div>

        <div *ngFor="let crewMember of crewChangeForm.get('DisembarkingCrewDetails').controls; let i=index; let last = last"
          [formGroupName]="i">
          <div class="form-container">

            <!-- Member Name -->
            <div class="form-group">
              <label for="Name">{{ 'FRONT_USER.CREW_CHANGE_FORM.MEMBER_NAME' | translate}}</label>
              <span class="red">*</span>
              <input type="text" formControlName="Name" class="form-control"
                [ngClass]="{ 'is-invalid':formSubmitted ||( crewMember.get('Name')?.dirty && crewMember.get('Name')?.errors) }" />
              <div
                *ngIf=" formSubmitted ||(crewMember.get('Name')?.dirty && crewMember.get('Name')?.errors)"
                class="red ">
                <div *ngIf="crewMember.get('Name')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <!-- PassportNumber -->
            <div class="form-group">
              <label for="PassportNumber">{{ 'FRONT_USER.CREW_CHANGE_FORM.PASSPORT_NUMBER' | translate}}</label>
              <span class="red">*</span>
              <input type="text" formControlName="PassportNumber" class="form-control"
                [ngClass]="{ 'is-invalid':formSubmitted ||( crewMember.get('PassportNumber')?.dirty && crewMember.get('PassportNumber')?.errors) }" />
              <div
                *ngIf=" formSubmitted ||(crewMember.get('PassportNumber')?.dirty && crewMember.get('PassportNumber')?.errors)"
                class="red ">
                <div *ngIf="crewMember.get('PassportNumber')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <!-- Attachment -->
            <div *ngIf="formMode != FormMode.Readonly" class="form-group">
              <label for="AttachmentURL">{{'FRONT_USER.CREW_CHANGE_FORM.DOCUMENT'| translate}}</label>
              <span *ngIf="formMode == FormMode.Add" class="red">*</span>
              <input type="file"
                accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                MaxSizeInMB="5" class="form-control" id="AttachmentURL" formControlName="AttachmentURL"
                (change)="onFileSelected($event,crewMember.get('AttachmentURL'),i,'D')" />
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>

              <!-- Progress Bar -->
              <div class="progress">
                <div  class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                  aria-valuemax="100" [style.width]="documentProgressD[i] + '%'">
                  <span class=""> {{ documentProgressD[i] }} % Complete</span>
                </div>
              </div>
              <div *ngIf=" formSubmitted ||(crewMember.get('AttachmentURL')?.dirty &&  crewMember.get('AttachmentURL')?.errors)"
                class="red">
                <div *ngIf="crewMember.get('AttachmentURL')?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
                <div *ngIf="crewMember.get('AttachmentURL').errors?.notCompleted">
                    {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && requestCrewDetailsDisembarking[i] && showDisembarkingURL">
              <label>{{'FRONT_USER.CREW_CHANGE_FORM.DOCUMENT'|translate}}</label>
              <a [attr.href]="uploadUrl+uploadFolder+'/'+requestCrewDetailsDisembarking[i].AttachmentURL" target="_blank">
                <i class="icon-view-file"></i>
                {{requestCrewDetailsDisembarking[i].AttachmentURL?.split("_").slice(0, -1).join('_')}} <!-- Split the name of the file, take all the name except the last part after the last ('_') -->
              </a>
            </div>

            <input type="hidden" formControlName="ChangeDirection" [ngModel]="changeDirection.Disembarking">
            <input type="hidden" formControlName="AddedBy" [ngModel]="currentUser.UserName">
            <input type="hidden" formControlName="Id">

            <p *ngIf="formMode != FormMode.Readonly">
              <button type="button" class="btn SCAcustomBtn" Confirmation
                (confirmationClick)="deleteCrewMember('D',i)"
                *ngIf="disembarkingCrewDetailsLength > 1">
                {{'FRONT_USER.DELETE' | translate }}
              </button>
            </p>
          </div>
          <p *ngIf="last && formMode != FormMode.Readonly " class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="addCrewMember('D')">(+)
              {{'FRONT_USER.ADD' | translate }}</button>
          </p>

          <!--Added By Admin  -->
          <div class="form-group" *ngIf="getCrewMemberAddedBy(crewMember.get('Id').value) !== crewChangeDTO?.RequestorEmail">
            <label style="
              background-color: antiquewhite;
              padding: 5px 10px;
              margin: 5px;
              border-radius: 5px;">{{'FRONT_USER.CREW_CHANGE_FORM.ADDED_BY_ADMIN' | translate }}
            </label>
          </div>
          <!--Final Notes  -->
          <div class="form-group" *ngIf="getCrewMemberFinalNotes(crewMember.get('Id').value) !== ''">
            <label style="    
              background-color: antiquewhite;
              padding: 5px 10px;
              margin: 5px;
              border-radius: 5px;">{{'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.FINAL_NOTES' | translate }} : {{getCrewMemberFinalNotes(crewMember.get('Id').value)}}
            </label>
          </div>
        </div>
      </div>

      <p class="btns-holder text-right">
        <button type="button" class="btn SCAcustomBtn"
          (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
      </p>

      </tab>
    </tabset>

      <div class="form-group" *ngIf="formMode != FormMode.Readonly && validateSubmitButton">
        <label for="TermsAndConditions">{{ 'FRONT_USER.TERMS_CONDITIONS' | translate }}</label>
        <span class="red"> *</span>

        <div class="form-custom-inputs">
          <div class="custom-checkbox">
            <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
              formControlName="TermsAndConditions" />
            <label for="TermsAndConditions">
              <a (click)="goToTermsAndCond()" target="_blank">
                {{ 'FRONT_USER.TERMS_CONDITIONS_Acceptence' | translate }}
              </a>
            </label>

          </div>
        </div>
        <div *ngIf="formSubmitted ||(f.TermsAndConditions.dirty && f.TermsAndConditions?.errors)" class="red ">
          <div *ngIf="f.TermsAndConditions?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

    <p class="form-group" *ngIf="formMode != FormMode.Readonly && (validateSubmitButton || showSubmit) ">
      <button Confirmation (confirmationClick)="onSubmit()"
        class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
   </form>
   <div *ngIf="requestStatus == serviceStatus.CrewChange_CrewChangeDone">
   <div class="form-container">
    <h4 class="section-title ">{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.TITLE' | translate }}</h4>
  </div>
  <div class="request-summary">
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.ACTUAL_DATE' | translate }}: </label>
      <label>{{actualDate | date: 'dd/MM/yyyy H:mm:ss'}}</label>
    </div>
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.ACTUAL_FEES' | translate }}: </label>
      <label>{{actualFees}}</label>
    </div>
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.ACTUAL_SERVICE_LOCATION' | translate }}: </label>
      <label>{{actualLocation}}</label>
    </div>
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.ACTUAL_SERVICE_TYPE' | translate }}: </label>
      <label>{{actualService}}</label>
    </div>
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.FINAL_NOTES' | translate }}: </label>
      <label>{{finalNotes}}</label>
    </div>
    <div class="request-summary-details">
      <label>{{ 'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.INVOICE_URL' | translate }}: </label>
      <label><a href="{{invoiceURL}}" class="clickable-ele" target="_blank"> {{'ADMIN_USER.CREW_CHANGE.ACTUAL_REQUEST_DETAILS.INVOICE' | translate}}</a></label>
    </div>
  </div>
</div>
</div>
<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>


  </div>
</div>


<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- <div *ngIf="!showRequest && ( (!currentUser.IsAdmin && currentUser.UserId == agentId) || currentUser.IsAdmin )"> -->
    <app-messaging ></app-messaging>
<!-- </div> -->
